export default __webpack_public_path__ + "static/media/add-icon.e9074d95.svg";